import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { fontSizes, fontWeights } from "../../../design-system/tokens/typography";

/** The sentence: 18px 500 text on a 44px line (F16 `.sent`), pickers inline. */
export const Sentence = styled.div`
  font-size: ${fontSizes.h5};
  font-weight: ${fontWeights.medium};
  /* GAP(sentenceLine): 44px line */
  line-height: 2.75rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing[1]} ${spacing[2]};
  margin: 0;
  min-height: 2.75rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Stack = styled.div`
  display: grid;
  gap: ${spacing[3]};
  min-width: 0;
`;

/** A picker with its trailing comma attached, so the comma never wraps onto the next line alone. */
export const Comma = styled.span<{ $show: boolean }>`
  display: inline-flex;
  flex: none;
  align-items: center;
  max-width: 100%;

  &::after {
    content: "${({ $show }) => ($show ? "," : "")}";
  }
`;
